import api from './api';

// Misma clave de sesión quincenal que usa el backend para los módulos "por CT"
export const sesionActualPorCT = () => {
    const ahora = new Date();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const q = ahora.getDate() <= 15 ? 'Q1' : 'Q2';
    return `${ahora.getFullYear()}-${mes}-${q}`;
};

// Factory genérica para los módulos "checklist por CT, cargado vía Excel"
// (CCTV, CI-Generales, y los que se agreguen después). `basePath` debe
// coincidir con el prefijo del router montado en el backend (ej. "/cctv").
export const crearChecklistPorCTService = (basePath) => ({
    listarCts: async () => {
        const response = await api.get(`${basePath}/cts`);
        return response.data?.cts || [];
    },

    checklist: async (ct, sesion = null) => {
        const response = await api.get(`${basePath}/checklist`, {
            params: { ct, sesion: sesion || sesionActualPorCT() },
        });
        return response.data;
    },

    // `extra` permite mandar campos adicionales (ej. operatividad/area_despejada/
    // estado_fisico para el formato RE09 de CCTV) sin afectar a los demás módulos.
    responder: async (itemId, respuesta, observaciones, sesion, ct, extra = {}) => {
        const response = await api.post(`${basePath}/responder`, {
            item_id: itemId,
            respuesta,
            observaciones,
            sesion: sesion || sesionActualPorCT(),
            ct,
            ...extra,
        });
        return response.data;
    },

    enviarReporte: async (email, ct, sesion = null) => {
        const response = await api.post(`${basePath}/reporte/enviar`, {
            email,
            ct,
            sesion: sesion || null,
        });
        return response.data;
    },

    historial: async ({ anio = null, mes = null, ct = null } = {}) => {
        const params = {};
        if (anio !== null && anio !== '') params.anio = anio;
        if (mes !== null && mes !== '') params.mes = mes;
        if (ct !== null && ct !== '') params.ct = ct;
        const response = await api.get(`${basePath}/historial`, { params });
        return response.data;
    },

    importarChecklistExcel: async (ct, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${basePath}/checklist/importar-excel`, formData, {
            params: { ct },
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    eliminarChecklist: async (ct) => {
        const response = await api.delete(`${basePath}/checklist`, { params: { ct } });
        return response.data;
    },

    descargarPlantilla: async (nombreArchivo) => {
        const response = await api.get(`${basePath}/checklist/plantilla`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nombreArchivo);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    descargarReporte: async (ct, sesion, nombreModulo) => {
        const response = await api.get(`${basePath}/reporte/descargar`, {
            params: { ct, sesion: sesion || undefined },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        const ctSlug = ct.replace(/\s+/g, '_');
        link.setAttribute('download', `inspeccion_${nombreModulo}_${ctSlug}_${sesion || 'actual'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    descargarReporteExcel: async (ct, sesion, nombreModulo) => {
        const response = await api.get(`${basePath}/reporte/descargar-excel`, {
            params: { ct, sesion: sesion || undefined },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        const link = document.createElement('a');
        link.href = url;
        const ctSlug = ct.replace(/\s+/g, '_');
        link.setAttribute('download', `inspeccion_${nombreModulo}_${ctSlug}_${sesion || 'actual'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    // Excel consolidado con todos los Centros de Trabajo de la inspectoria (una sesión)
    descargarReporteExcelInspectoria: async (sesion, nombreModulo) => {
        const response = await api.get(`${basePath}/reporte/descargar-excel-inspectoria`, {
            params: { sesion: sesion || undefined },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `inspeccion_${nombreModulo}_toda_inspectoria_${sesion || 'actual'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
});
